<div *ngIf="(pageVm$ | async) as pvm">

    <!-- loader -->
    <app-page-loader [pageLoaderVm]="pvm"></app-page-loader>

    <!-- header -->
    <app-page-header *ngIf="pvm.pageHeaderVm" [pageHeaderVm]="pvm.pageHeaderVm" (backClicked)="backClicked(pvm)"
        (editClicked)="editClicked(pvm)" (deleteClicked)="deleteClicked(pvm)"
        (infoClicked)="infoClicked(pvm)" (copyClicked)="copyClicked(pvm)"></app-page-header>

    <!-- content -->
    <div *ngIf="pvm.contentVm as vm">

        <!-- forms -->
        <div *ngIf="vm.formVm as fvm">
            <div class="row">
                <div class="col-md-12">

                    <!-- disclaimer form -->
                    <div *ngIf="fvm.type == 'disclaimer'">
                        <mdb-card narrower="true" cascade="true">
                            <div class="row">
                                <div class="col-md-6">
                                    <app-card-header [headingSize]="2" [title]="fvm.title">
                                    </app-card-header>
                                </div>
                            </div>
                            <mdb-card-body cascade="true">
                                <h3>Assumptions</h3>
                                <ul>
                                    <li>Only initial downpayment as capital used. Otherwise if calculating sale, IRR
                                        would be more accurate.</li>
                                    <li>Assumes yearly compounded Rental and Property appreciations.</li>
                                    <li>Does not account for tax deductions paid on interest or insurance.</li>
                                    <li>Does not account for changes in tax structuring.</li>
                                    <li>Assumes no refinance.</li>
                                </ul>

                                <p>
                                ** No results are guranteed as there are many variables.<br/>
                                ** This tool should only be used as an initial analysis for the projected returns on an
                                investment property.<br/>
                                ** Please run your own calcualtions for further due diligence & seek help from the
                                appropriate professionals when considering investing, financial, tax or legal advice.<br/>
                                </p>
                            </mdb-card-body>
                        </mdb-card>
                    </div>

                    <!-- property copy form-->
                    <div *ngIf="fvm.type == 'property-copy'">
                        <mdb-card narrower="true" cascade="true">
                            <div class="row">
                                <div class="col-md-6">
                                    <app-card-header [headingSize]="2" [title]="fvm.title">
                                    </app-card-header>
                                </div>
                            </div>
                            <mdb-card-body cascade="true">
                                <div class="text-center">
                                    <span>Are you sure?</span>
                                </div>
                            </mdb-card-body>
                        </mdb-card>
                    </div>

                    <!-- property delete form-->
                    <div *ngIf="fvm.type == 'property-delete'">
                        <mdb-card narrower="true" cascade="true">
                            <div class="row">
                                <div class="col-md-6">
                                    <app-card-header [headingSize]="2" [title]="fvm.title">
                                    </app-card-header>
                                </div>
                            </div>
                            <mdb-card-body cascade="true">
                                <div class="text-center">
                                    <span>Are you sure?</span>
                                </div>
                            </mdb-card-body>
                        </mdb-card>
                    </div>

                    <!-- property new form -->
                    <div *ngIf="fvm.type == 'property-new'">
                        <mdb-card narrower="true" cascade="true">
                            <div class="row">
                                <div class="col-md-6">
                                    <app-card-header [headingSize]="2" [title]="fvm.title">
                                    </app-card-header>
                                </div>
                            </div>
                            <mdb-card-body cascade="true">
                                <div class="alert alert-warning" role="alert">
                                    Start by entering some basic information below.  More advanced options will be available later.
                                </div>
                                <div class="row">
                                    <div class="col-md-3">
                                        <app-form-input [vm]="fvm.name"
                                            (textChanged)="propertyNewFormChanged(vm, fvm)"></app-form-input>
                                    </div>
                                    <div class="col-md-9">
                                        <app-form-input [vm]="fvm.address"
                                            (textChanged)="propertyNewFormChanged(vm, fvm)"></app-form-input>
                                    </div>
                                    <div class="col-md-12">
                                        <app-form-input [vm]="fvm.description"
                                            (textChanged)="propertyNewFormChanged(vm, fvm)"></app-form-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-4">
                                        <app-form-input [vm]="fvm.purchaseDate"
                                            (textChanged)="propertyNewFormChanged(vm, fvm)"></app-form-input>
                                    </div>
                                    <div class="col-md-4">
                                        <app-form-input [vm]="fvm.purchasePrice" [text]="fvm.data.purchasePrice | number:'1.0':'en-US'"
                                            (textChanged)="propertyNewFormPurchasePriceChanged(vm, fvm)"></app-form-input>
                                    </div>
                                    <div class="col-md-4">
                                        <app-form-input [vm]="fvm.marketValue" [text]="fvm.data.marketValue | number:'1.0':'en-US'"
                                            (textChanged)="propertyNewFormChanged(vm, fvm)"></app-form-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-4">
                                        <app-form-input [vm]="fvm.monthlyRevenue" [text]="fvm.data.monthlyRevenue | number:'1.0':'en-US'"
                                            (textChanged)="propertyNewFormChanged(vm, fvm)"></app-form-input>
                                    </div>
                                    <div class="col-md-4" *ngFor="let ivm of fvm.yearlyExpenses">
                                        <app-form-input [vm]="ivm" [text]="fvm.data.yearlyExpenses[ivm.field] | number:'1.0':'en-US'"
                                            (textChanged)="propertyNewFormChanged(vm, fvm)"></app-form-input>
                                    </div>
                                    <div class="col-md-4">
                                        <app-form-input [vm]="fvm.propertyManagement" 
                                            (textChanged)="propertyNewFormChanged(vm, fvm)"></app-form-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <app-form-checkbox [vm]="fvm.hasLoan"
                                            (checkChanged)="propertyNewFormChanged(vm, fvm)"></app-form-checkbox>
                                    </div>
                                </div>
                                <div class="row" *ngIf="fvm.data.hasLoan">
                                    <div class="col-md-3">
                                        <app-form-input [vm]="fvm.loanParams.years" 
                                            (textChanged)="propertyNewFormChanged(vm, fvm)"></app-form-input>
                                    </div>
                                    <div class="col-md-3">
                                        <app-form-input [vm]="fvm.loanParams.rate" 
                                            (textChanged)="propertyNewFormChanged(vm, fvm)"></app-form-input>
                                    </div>
                                    <div class="col-md-3">
                                        <app-form-input [vm]="fvm.loanParams.closingCosts" [text]="fvm.data.loanParams.closingCosts | number:'1.0':'en-US'"
                                            (textChanged)="propertyNewFormChanged(vm, fvm)"></app-form-input>
                                    </div>
                                    <div class="col-md-3">
                                        <app-form-input [vm]="fvm.loanParams.percentDown" 
                                            (textChanged)="propertyNewFormChanged(vm, fvm)"></app-form-input>
                                    </div>
                                </div>
                            </mdb-card-body>
                        </mdb-card>

                    </div>

                    <!-- property edit form -->
                    <div *ngIf="fvm.type == 'property-edit'">

                        <mdb-card narrower="true" cascade="true">
                            <div class="row">
                                <div class="col-md-6">
                                    <app-card-header [headingSize]="2" [title]="fvm.title">
                                    </app-card-header>
                                </div>
                                <!-- 2/13/23, disabled for now. add some type of grouping method to allow properties to be grouped on home page -->
                                <!-- <div class="col-md-6">
                                    <app-form-checkbox [vm]="fvm.inactive"
                                        (checkChanged)="propertyEditFormLoanCheckboxChanged(vm, fvm)"></app-form-checkbox>
                                </div> -->
                            </div>
                            <mdb-card-body cascade="true">


                                <mdb-tabset #tabset [buttonClass]="'rtr-pills-green-bold white mb-2'"
                                    [contentClass]="'tabset-clear-content'">

                                    <!-- photos -->
                                    <mdb-tab *ngIf="fvm.photosTabVm as tvm" [heading]="tvm.title">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <app-file-entry-list
                                                    [vm]="tvm.photoFileEntryList"></app-file-entry-list>
                                            </div>
                                        </div>
                                    </mdb-tab>

                                    <!-- general -->
                                    <mdb-tab *ngIf="fvm.generalTabVm as tvm" [heading]="tvm.title">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <app-form-input [vm]="tvm.name"
                                                    (textChanged)="propertyEditFormChanged(vm, fvm)">
                                                </app-form-input>
                                            </div>
                                            <div class="col-md-8">
                                                <app-form-input [vm]="tvm.address"
                                                    (textChanged)="propertyEditFormChanged(vm, fvm)">
                                                </app-form-input>
                                            </div>
                                            <div class="col-md-12">
                                                <app-form-input [vm]="tvm.description"
                                                    (textChanged)="propertyEditFormChanged(vm, fvm)">
                                                </app-form-input>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-4">
                                                <app-form-input [vm]="tvm.purchaseDate"
                                                    (textChanged)="propertyEditFormChanged(vm, fvm)">
                                                </app-form-input>
                                            </div>
                                            <div class="col-md-4">
                                                <app-form-input [vm]="tvm.purchasePrice" [text]="tvm.purchasePrice.context[tvm.purchasePrice.field] | number:'1.0':'en-US'"
                                                    (textChanged)="propertyEditFormChanged(vm, fvm)">
                                                </app-form-input>
                                            </div>
                                            <div class="col-md-4">
                                                <app-form-input [vm]="tvm.purchaseCosts" [text]="tvm.purchaseCosts.context[tvm.purchaseCosts.field] | number:'1.0':'en-US'"
                                                    (textChanged)="propertyEditFormChanged(vm, fvm)">
                                                </app-form-input>
                                            </div>
                                        </div>
                                    </mdb-tab>

                                    <!-- pro forma -->
                                    <mdb-tab *ngIf="fvm.proFormaTabVm as tvm" [heading]="tvm.title">

                                        <div class="row">
                                            <div class="col-md-4">
                                                <app-form-input [vm]="tvm.marketValue" [text]="tvm.marketValue.context[tvm.marketValue.field] | number:'1.0':'en-US'"
                                                    (textChanged)="propertyEditFormChanged(vm, fvm)">
                                                </app-form-input>
                                            </div>
                                            <div class="col-md-4">
                                                <app-form-input [vm]="tvm.monthlyRevenue" [text]="tvm.monthlyRevenue.context[tvm.monthlyRevenue.field] | number:'1.0':'en-US'"
                                                    (textChanged)="propertyEditFormChanged(vm, fvm)">
                                                </app-form-input>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-4" *ngFor="let evm of tvm.yearlyExpenses">
                                                <app-form-input [vm]="evm" [text]="evm.context[evm.field] | number:'1.0':'en-US'"
                                                    (textChanged)="propertyEditFormChanged(vm, fvm)">
                                                </app-form-input>
                                            </div>

                                        </div>

                                    </mdb-tab>

                                    <!-- loan  -->
                                    <mdb-tab *ngIf="fvm.loanTabVm as tvm" [heading]="tvm.title">

                                        <!-- control loan usage -->
                                        <div class="row">
                                            <div class="col-md-12 text-center">
                                                <app-form-checkbox [vm]="tvm.hasLoan"
                                                    (checkChanged)="propertyEditFormLoanCheckboxChanged(vm, fvm)">
                                                </app-form-checkbox>
                                            </div>
                                        </div>

                                        <!-- each loan field -->
                                        <div class="row" *ngIf="tvm.fields">
                                            <div class="col-md-3" *ngFor="let livm of tvm.fields">
                                                <app-form-input [vm]="livm" *ngIf="livm.type == 'number-text'" [text]="livm.context[livm.field] | number:'1.0':'en-US'"
                                                    (textChanged)="propertyEditFormChanged(vm, fvm)"></app-form-input>
                                                <app-form-input [vm]="livm" *ngIf="livm.type != 'number-text'"
                                                    (textChanged)="propertyEditFormChanged(vm, fvm)"></app-form-input>
                                            </div>
                                        </div>

                                    </mdb-tab>

                                    <!-- investment variables -->
                                    <mdb-tab *ngIf="fvm.investmentVariablesTabVm as tvm" [heading]="tvm.title">
                                        <div class="row">
                                            <div class="col-md-4" *ngFor="let ivm of tvm.fields">
                                                <app-form-input [vm]="ivm"
                                                    (textChanged)="propertyEditFormChanged(vm, fvm)"></app-form-input>
                                            </div>
                                        </div>
                                    </mdb-tab>

                                </mdb-tabset>

                            </mdb-card-body>
                        </mdb-card>

                    </div>

                    <!-- loan form -->
                    <div *ngIf="fvm.type == 'loan-view'">
                        <mdb-card narrower="true" cascade="true">
                            <div class="row">
                                <div class="col-md-6">
                                    <app-card-header [headingSize]="2" [title]="fvm.title">
                                    </app-card-header>
                                </div>
                            </div>
                            <mdb-card-body cascade="true">
                                <div style="height: 640px; overflow: auto;">
                                    <table mdbTable striped="true" small="true">
                                        <thead>
                                            <tr>
                                                <th class="text-center" scope="col">No.</th>
                                                <th class="text-center" scope="col">Start</th>
                                                <th class="text-center" scope="col">Principal</th>
                                                <th class="text-center" scope="col">Interest</th>
                                                <th class="text-center" scope="col">End</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let p of fvm.payments">
                                                <td class="text-center" style="min-width: 10em;">
                                                    <span>{{p.title}}</span>
                                                </td>
                                                <td class="text-center" style="min-width: 10em;">
                                                    <span>{{p.start}}</span>
                                                </td>
                                                <td class="text-center" style="min-width: 10em;">
                                                    <span>{{p.principal}}</span>
                                                </td>
                                                <td class="text-center" style="min-width: 10em;">
                                                    <span>{{p.interest}}</span>
                                                </td>
                                                <td class="text-center" style="min-width: 10em;">
                                                    <span>{{p.end}}</span>
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>

                                </div>
                            </mdb-card-body>
                        </mdb-card>
                    </div>

                    <!-- ok / cancel -->
                    <div *ngIf="fvm.okCancelVm" class="pt-2">
                        <app-form-ok-cancel [vm]="fvm.okCancelVm" (okClicked)="formComplete(pvm, fvm)"
                            (cancelClicked)="formCancel(pvm)">
                        </app-form-ok-cancel>
                    </div>

                </div>
            </div>
        </div>

        <!-- main -->
        <div class="row" *ngIf="!vm.formVm">

            <!-- left side -->
            <div class="col-lg-4" *ngIf="vm.infoVm as tvm">

                <!-- picture -->
                <div class="row pb-3" *ngIf="tvm.pictureUrl">
                    <div class="col-md-12">
                        <div class="view overlay" style="border-radius: 5px; height: 180px;">
                            <app-form-file-image [imageData]="tvm.pictureUrl"></app-form-file-image>
                        </div>
                    </div>
                </div>

                <!-- panels -->
                <div class="row">

                    <!-- each panel -->
                    <div *ngFor="let svm of tvm.panelVms" class="col-md-12 pb-3">
                        <mdb-card narrower="true" cascade="true">
                            <div class="row">
                                <div class="col-lg-6 pr-0">
                                    <app-card-header [headingSize]="5" [title]="svm.title" [helpHtml]="svm.helpHtml">
                                    </app-card-header>
                                </div>
                                <div class="col-lg-6 text-lg-left text-center pt-md-0 pt-3">
                                    <app-badge *ngIf="svm.badgeVm" [vm]="svm.badgeVm"></app-badge>
                                    <a class="action-link" *ngFor="let a of svm.actions" [mdbTooltip]="a.tooltip"
                                        (click)="infoPanelActionStart(pvm, a.code)">{{a.title}}</a>
                                </div>
                            </div>
                            <mdb-card-body>
                                <mdb-card-text class="pb-0">

                                    <div *ngFor="let s of svm.sections">

                                        <div *ngIf="s.title !== undefined">
                                            <h5 class="pb-0 mb-0 pt-3" *ngIf="s.title !== ''"><b>{{s.title}}</b></h5>
                                            <hr class="mb-3 mt-1" />
                                        </div>

                                        <div class="d-flex flex-wrap">
                                            <div class="pr-5 pb-2" *ngFor="let i of s.items">
                                                <strong>{{i.title}}</strong>
                                                <app-form-help *ngIf="i.helpHtml" [html]="i.helpHtml"></app-form-help>
                                                <div>{{i.value}}</div>
                                            </div>
                                        </div>

                                    </div>

                                </mdb-card-text>
                            </mdb-card-body>
                        </mdb-card>
                    </div>
                </div>

            </div>

            <!-- right side -->
            <div class="col-lg-8">

                <!-- charts -->
                <div class="row" *ngIf="vm.chartVms">

                    <div class="pb-3 col-md-6" *ngFor="let cvm of vm.chartVms">

                        <mdb-card narrower="true" cascade="true">
                            <div class="row">
                                <div class="col-md-8">
                                    <app-card-header [headingSize]="5" [title]="cvm.title" [helpHtml]="cvm.helpHtml">
                                    </app-card-header>
                                </div>
                            </div>

                            <mdb-card-body cascade="true">
                                <div style="display: block;">
                                    <canvas mdbChart [chartType]="cvm.chartType" [datasets]="cvm.chartDatasets"
                                        style="max-height: 180px;" [labels]="cvm.chartLabels" [colors]="cvm.chartColors"
                                        [options]="cvm.chartOptions" [legend]="false">
                                    </canvas>
                                </div>
                            </mdb-card-body>
                        </mdb-card>
                    </div>

                </div>

                <!-- investment year by year -->
                <div *ngIf="vm.investmentYearsVm as dvm">
                    <div *ngIf="dvm.tableVm as tableVm">
                        <div class="row" *ngFor="let r of tableVm.rows">
                            <div class="col-md-12 pb-3">

                                <mdb-card narrower="true" cascade="true">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <app-card-header [headingSize]="5" [title]="r.title"
                                                [helpHtml]="r.helpHtml">
                                            </app-card-header>
                                        </div>
                                        <div class="col-lg-4 text-lg-left text-center pt-md-0 pt-3">
                                            <a class="action-link" *ngFor="let a of r.actions"
                                                (click)="investmentYearActionStart(pvm, r.calendarYear, a.code)">{{a.title}}</a>
                                        </div>
                                    </div>
                                    <mdb-card-body cascade="true">
                                        <div class="row">
                                            <div class="col-md-4" *ngFor="let c of r.cells">
                                                <div class="text-center">
                                                    <h6 class="pb-0 mb-0">{{c.title}}
                                                        <app-form-help *ngIf="c.helpHtml" [html]="c.helpHtml"></app-form-help>
                                                    </h6>
                                                    <hr />
                                                </div>
                                                <div *ngFor="let i of c.items" class="d-flex ">

                                                    <div *ngIf="i.value === undefined" style="width: 100%;">
                                                        <hr />
                                                    </div>

                                                    <div *ngIf="i.value !== undefined" class="text-left"
                                                        style="width: 50%;">

                                                        <!-- cashflow template-->
                                                        <ng-template #cashflowTemplate>
                                                            <div *ngIf="!i.items">
                                                                <span>Coming soon</span>
                                                            </div>
                                                            <div style="width:200px;" *ngIf="i.items">
                                                                <div class="d-flex" *ngFor="let i2 of i.items">
                                                                    <div *ngIf="i2.value === undefined"
                                                                        style="width: 100%;">
                                                                        <hr />
                                                                    </div>

                                                                    <div *ngIf="i2.value !== undefined"
                                                                        class="text-left" style="width: 50%">
                                                                        <small class="text-muted">{{i2.title}}</small>
                                                                    </div>
                                                                    <div *ngIf="i2.value !== undefined"
                                                                        class="text-right" style="width: 50%">
                                                                        <hr *ngIf="i2.isTotal"/>
                                                                        <strong class="pl-2">{{i2.value}}</strong>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ng-template>

                                                        <small class="text-muted">{{i.title}}</small>
                                                        <app-form-help *ngIf="i.templateId == 'cashflowTemplate'"
                                                            [templateId]="cashflowTemplate"></app-form-help>
                                                        <app-form-help *ngIf="i.helpHtml"
                                                            [html]="i.helpHtml"></app-form-help>
                                                    </div>
                                                    <div *ngIf="i.value !== undefined" class="text-right"
                                                        style="width:50%;">             
                                                        <hr *ngIf="i.isTotal" class="m-0"/>                                           
                                                        <strong class="pl-2">{{i.value}}</strong>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </mdb-card-body>
                                </mdb-card>

                            </div>
                        </div>

                    </div>

                </div>


            </div>


        </div>
    </div>
</div>